import script from "./J1939LampChips.vue?vue&type=script&setup=true&lang=js"
export * from "./J1939LampChips.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__